import { AxiosResponse } from "axios";
import { ApiError } from "../../../domain/errors";

export const successInterceptor = (response: AxiosResponse) => {
  if (response.data && response.data.status === false) {
    const error = response.data.message || "Ocorreu um erro no servidor";
    return Promise.reject(new ApiError(error));
  }

  const result = {
    ...response.data,
    has_pagination: !!(
      response.data.next_page_url || response.data.prev_page_url
    ),
    is_empty:
      response.data.total === 0 ||
      (response.data.data && response.data.data.length === 0),
    links: response.data?.links?.slice(1, -1) || [],
  };

  return result;
};
